module.exports = __webpack_public_path__ + "static/media/binoculars.fce990bd.svg";